class WebSocketService {
  static instance = null;
  callbacks = {};

  static getInstance() {
    if (!WebSocketService.instance) {
      WebSocketService.instance = new WebSocketService();
    }
    return WebSocketService.instance;
  }

  constructor() {
    this.socketRef = null;
  }

  connect(chatURL) {
    const path = `wss://tn-chat-app.herokuapp.com/ws/chat/${chatURL}/`;
    this.socketRef = new WebSocket(path);
    this.socketRef.onopen = () => {};
    this.socketRef.onmessage = (e) => {
      this.socketNewMessage(e.data);
    };
    this.socketRef.onerror = (e) => {
      console.log(e.message);
    };
    this.socketRef.onclose = () => {
      console.log("WebSocket closed let's reopen");
    };
  }

  disconnect() {
    if (this.socketRef) {
      this.socketRef.close();
      this.socketRef = null;
    }
  }
  socketNewMessage(data) {
    const parsedData = JSON.parse(data);
    const command = parsedData.command;
    if (Object.keys(this.callbacks).length === 0) {
      return;
    } else if (command === 'messages') {
      this.callbacks[command](parsedData.messages);
    } else if (command === 'new_message') {
      this.callbacks[command](parsedData.message);
    }
  }

  fetchMessages(id, chatID) {
    this.sendMessage({
      command: 'fetch_messages',
      username: id,
      chatId: chatID,
    });
  }

  newChatMessage(message) {
    this.sendMessage({
      command: 'new_message',
      from: message.from,
      message: message.content,
      chatId: message.chatId,
      token: message.token,
    });
  }

  addCallbacks(messagesCallback, newMessageCallback) {
    this.callbacks['messages'] = messagesCallback;
    this.callbacks['new_message'] = newMessageCallback;
  }

  sendMessage(data) {
    try {
      this.socketRef.send(JSON.stringify({ ...data }));
    } catch (err) {
      console.log(err.message);
    }
  }

  state() {
    return this.socketRef.readyState;
  }
}

const WebSocketInstance = WebSocketService.getInstance();

export default WebSocketInstance;
